import { Lock, Snowflake, Ban, ShieldX } from "lucide-react";
import { Link } from "react-router-dom";
import { DLButton, Slogan } from "@/components/dl/ui";

// Renders the correct locked/placeholder state. Returns null when the player is
// eligible (entitled + active). NEVER grants access — purely presentational.
export default function EntitlementGate({ entitlement, children }) {
  if (entitlement && entitlement.effective_status === "active") return children || null;

  let icon = Lock, title = "Case Pass required", desc = "You need a Defense League Case Pass to join a team and play this case.", cta = null, testid = "dl-gate-nopass";

  if (!entitlement) {
    cta = (
      <div className="flex flex-col items-center gap-2">
        <DLButton disabled data-testid="dl-casepass-cta">Get a Case Pass — Coming soon</DLButton>
        <span className="text-[11px] text-white/40 font-mono">Purchasing opens closer to launch.</span>
      </div>
    );
  } else if (entitlement.effective_status === "frozen") {
    icon = Snowflake; testid = "dl-gate-frozen";
    if (entitlement.member_active === false) {
      title = "Participation frozen"; desc = "Your HSTC membership has lapsed, so your Defense League participation is frozen. Nothing has been deleted — renew your membership to jump back in.";
      cta = <Link to="/pricing"><DLButton>Renew Membership</DLButton></Link>;
    } else {
      title = "Entitlement frozen"; desc = "Your Case entitlement has been frozen by the Commissioner. Reach out if you believe this is a mistake.";
    }
  } else if (entitlement.effective_status === "revoked") {
    icon = Ban; title = "Access revoked"; testid = "dl-gate-revoked";
    desc = "Your entitlement for this Case has been revoked.";
  }

  const Icon = icon;
  return (
    <div className="dl-panel-gold rounded-lg py-14 px-6 text-center flex flex-col items-center" data-testid={testid}>
      <div className="w-12 h-12 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center mb-4">
        <Icon className="w-6 h-6 text-gold" />
      </div>
      <Slogan className="block mb-1">Locker Room Locked</Slogan>
      <div className="font-display font-bold text-white text-xl">{title}</div>
      <p className="mt-2 text-sm text-white/55 max-w-md">{desc}</p>
      {cta && <div className="mt-6">{cta}</div>}
    </div>
  );
}

export function InactiveNotice() {
  return (
    <div className="dl-panel rounded-lg py-10 px-6 text-center" data-testid="dl-need-team">
      <ShieldX className="w-7 h-7 text-white/25 mx-auto mb-3" />
      <div className="font-display font-semibold text-white">Join a team first</div>
      <p className="mt-1 text-sm text-white/50">You need to be on a defense team for this Case to use this room.</p>
    </div>
  );
}
